export const SKUS_QUERY_STRING = Object.freeze({
  CATEGORY_ID: "categoryId",
  SUB_CATEGORY_ID: "subCategoryId",
  SKU_BRANDS: "skuBrandIdList",
  SKU_NAMES: "skuNameIdList",
  SKU_IDS: "skuIds",
});
